import { OperatorConfig } from "..";

// PREPROD
const sourcesConfig: OperatorConfig = {
  backoffice: {
    display: {
      "sidebar.menu.management.incidents": false,
      "sidebar.menu.management.visits": false,
      "feature.user.delete": false,
      "feature.user.forgot_password": false,
      "feature.dashboards.incidents": false,
      "feature.dashboards.realtime_incidents": false,
    },
  },
};

export default sourcesConfig;
